import { Card, Text } from "@shopify/polaris"

import FAQ from "./FAQ"
import AskedQuestions, { IProAskedQuestionsProps } from "./index"

interface IProAskedContentProps {
  subTitle: string
  list: IProAskedQuestionsProps[]
  type?: "card" | "collapsible"
}

const AskedContent = (props: IProAskedContentProps) => {
  const { subTitle, list, type } = props

  if (type === "collapsible") {
    return (
      <Card>
        <div className="space-y-4 faq-collapsible-container">
          <Text variant="headingMd" as="h2">
            {subTitle}
          </Text>
          <div className="space-y-3">
            {list.map((item) => (
              <FAQ {...item} key={item.title} />
            ))}
          </div>
        </div>
      </Card>
    )
  }

  return (
    <Card>
      <div className="flex flex-col gap-4">
        <Text variant="headingMd" as="h2">
          {subTitle}
        </Text>
        <div className="[--p-border-radius-300:8px]">
          {list.map((item) => (
            <AskedQuestions {...item} key={item.title} />
          ))}
        </div>
      </div>
    </Card>
  )
}

export default AskedContent
